import { useParams } from 'react-router';


export function useTickerIdParams() {
  const { tickerId } = useParams();

  return tickerId ? tickerId.toUpperCase() : null;
}
